import React, {useCallback} from "react";
import {useDropzone} from 'react-dropzone';

import {ApolloMessage, CustomizedSnackbars} from "./Apollo_Mesasge";
import {apollo_useStyles} from "./Apollo_styles";

type ApolloSingleFileSelectProps = {
  fileState: {
    file: any,
    setFile: any,
  },
  accept?: string,
  /** Maximum file size (in MByte) */
  maxSize?: number,
  setBinary?: any,
}

export function ApolloSingleFileSelect ({fileState, accept, maxSize, setBinary}: ApolloSingleFileSelectProps) {
  const classes = apollo_useStyles();
  const reader = new FileReader();
  const {data, setmsg} = React.useContext(ApolloMessage);

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles.length === 0) {
      fileState.setFile("")
      return;
    }

    if (!checkMaxSize(acceptedFiles[0].size)) {
      fileState.setFile("")
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `${maxSize}MB 以下のファイルを設定してください。`,
        }
      });
      return;
    }
    fileState.setFile(acceptedFiles)

    reader.onload = () => {
      if (setBinary) {
        setBinary(reader.result as string);
      }
    }
    reader.readAsDataURL(acceptedFiles[0]);
  }, []);

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    accept: accept ?? undefined,
    multiple: false,
    onDrop,
  });

  const checkMaxSize = (size: number | undefined) => {
    if (!size) {
      return true;
    }
    if (maxSize && maxSize != 0) {
      if (size > 1024*1024*maxSize) {
        return false;
      }
    }
    return true;
  }

  return (
    <React.Fragment>
      <CustomizedSnackbars/>
      <section
        className="container">
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <div className={classes.droparea}>
            <p className={classes.p}>
              ここにファイルをドラッグ＆ドロップ
              <br/>
              もしくは、クリックして選択
            </p>
          </div>
        </div>
        <ul id="file1">
          {fileState?.file[0]?.name ? <li>{fileState.file[0].name}</li> : undefined}
        </ul>
      </section>
    </React.Fragment>
  );
}
